import axios, { AxiosPromise } from 'axios';
import { IDevice } from '../../../@types/model/masterData/device/device';
import { IDeviceUpsert } from '../../../@types/model/masterData/device/deviceUpsert';


export default class DeviceHttpService {
    public static getDeviceData() : AxiosPromise<Array<IDevice>> {
        return axios.get(`${API_URL}/v1/Device/GetAllWeb`);
    }

    public static addOrUpdateDevice(upsert : IDeviceUpsert) : AxiosPromise<IDevice> {
        return axios.post(`${API_URL}/v1/Device/PostDevice`, upsert);
    }

    public static deleteDevice(deviceId : number) : AxiosPromise<IDevice> {
        return axios.delete(`${API_URL}/v1/Device/Delete`, {
            params : { deviceId },
        });
    }
}
